export default "__VITE_ASSET__BhLe3l4l__"